import { Component, input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
	BeforeAfter,
	convertObjectToCsv,
	getCsvTemplate,
	SetupWizardPayloadObjectKey,
	SetupWizardState,
} from '@mira-avant/mtlibs';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { SetupWizard } from '../../../../../services/setup-wizard';
import { FileHelper } from '../../../../../utils/file.helper';
import { firstValueFrom } from 'rxjs';

@Component({
	selector: 'app-setup-wizard-download-csv-button',
	imports: [NzButtonModule, NzIconModule, NzTooltipModule],
	standalone: true,
	templateUrl: './setup-wizard-download-csv-button.html',
	styleUrl: './setup-wizard-download-csv-button.scss',
})
export class SetupWizardDownloadCsvButton {
	public key = input<SetupWizardPayloadObjectKey>();
	public SetupWizardState = SetupWizardState;

	constructor(private setupWizard: SetupWizard) {}

	public async onDownload() {
		await firstValueFrom(this.setupWizard.preview$).then(data => {
			const key = this.key();

			if (!key) {
				throw new Error('SetupWizardPayloadObjectKey is required for downloading CSV template');
			}

			let output = '';

			//First apply header row
			const template = getCsvTemplate(key);
			output += template;

			//Now add the after property for each row in preview for this key if it exists, or the before row if it doesn't.
			const dataAsRecord = data.payload as Record<SetupWizardPayloadObjectKey, BeforeAfter<unknown>[]>;

			if (dataAsRecord && dataAsRecord[key]) {
				const rows = dataAsRecord[key];

				for (const row of rows) {
					//Determine whether to use the 'after' or 'before' property for this row
					const beforeAfter = row.after ?? row.before;

					//Convert the row to CSV
					const csv = convertObjectToCsv(
						//template comes with a trailing \n
						template.replace('\n', '').split(','),
						beforeAfter as Record<string, unknown>
					);

					output += csv + '\n';
				}
			}

			FileHelper.saveString(output, `${key}.csv`);
		});
	}
}
